import React, { useState, useEffect } from "react";
import "flatpickr/dist/flatpickr.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-daterangepicker/daterangepicker.css";
import { useHistory } from "react-router-dom";
import Repository from "../../../configs/axios/repository";
import Spinner from "../../../@core/components/spinner/Fallback-spinner";
import { Card, CardBody, Row, Col } from "reactstrap";
import { convertToRaw, EditorState } from "draft-js";
import ReactJson from "react-json-view";

import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from "draftjs-to-html";

const TestWithGPT = (props) => {
    const history = useHistory();
    const [loadingData, setLoadingData] = useState(true);
    const [prompt, setPrompt] = useState("");
    const [note, setNote] = useState("");
    const [resultData, setResultData] = useState(null);
    // *****
    const [editorState, setEditorState] = useState(EditorState.createEmpty());

    const onEditorStateChange = (newEditorState) => {
        setEditorState(newEditorState);
        const currentContent = newEditorState.getCurrentContent();
        const rawContentState = convertToRaw(currentContent);

        // const plainText = currentContent.getPlainText("\u0001");
        // Convert the raw content state to HTML
        const html = draftToHtml(rawContentState);

        setNote(html);
    };
    function checkType(value) {
        try {
            if (typeof value === "string") {
                if (value.startsWith("```json")) {
                    try {
                        let data = value
                            .replace(/```json/g, "")
                            .replace(/```/g, "");
                        let jsonArray = JSON.parse(data);

                        // Return React element with ReactJson component
                        return <ReactJson src={jsonArray} />;
                    } catch (e) {
                        // Return the original string if parsing fails
                        return value;
                    }
                } else {
                    try {
                        // Attempt to parse as JSON
                        let parsedValue = JSON.parse(value);

                        // Return React element with parsed JSON
                        return <ReactJson src={parsedValue} />;
                    } catch (e) {
                        // Return the original string if parsing fails
                        return value;
                    }
                }
            } else if (typeof value === "object" && value !== null) {
                // If value is already an object, return React element with ReactJson component
                return <ReactJson src={value} />;
            }
        } catch (e) {
            // Return the original value if an error occurs
            return value;
        }
    }
    const handleSubmit = async (event) => {
        event.preventDefault();

        setLoadingData(false);
        let data = {
            note: `${note}`,
            prompt: `${prompt}`,
        };

        const result = await Repository.postRequest(
            `api/gpt/makeChatCompletion`,
            data
        );
        if (result.data.success == true) {
            setResultData(result.data.data);
            setLoadingData(true);
            window.scrollTo({
                top: 600,
                behavior: "smooth",
            });
        }
        setLoadingData(true);
    };

    return loadingData ? (
        <div className="mt-4">
            <div className="d-flex justify-content-between">
                <div className="clidrenDivCompakt testH1">
                    <div className="mt-4 ">
                        <h1 className="noteTitle">Test with ChatGPt</h1>
                    </div>
                </div>
            </div>
            <CardBody>
                <div>
                    <form onSubmit={handleSubmit}>
                        <Row>
                            <Col xl="12" md="12" sm="12">
                                <textarea
                                    value={prompt}
                                    onChange={(e) => {
                                        setPrompt(e.target.value);
                                    }}
                                    name="prompt"
                                    className="textareaTestGpt"
                                    placeholder="Prompt*"
                                    maxLength={200000}
                                />
                            </Col>

                            <Col xl="12" md="12" sm="12">
                                <div className="tabMenuCreateNote">
                                    <div className="tabs mt-3"></div>
                                    <div className="mt-3">
                                        <span>
                                            {note?.length}
                                            /200000
                                        </span>
                                    </div>
                                </div>

                                <Editor
                                    editorState={editorState}
                                    onEditorStateChange={onEditorStateChange}
                                    toolbarClassName="toolbarClassName"
                                    wrapperClassName="wrapperClassName"
                                    editorClassName="editorClassName"
                                    placeholder="Your note*"
                                />
                            </Col>
                            <Col xl="12" md="12" sm="12">
                                <div className="testBtn mt-1 mb-4">
                                    <button
                                        onClick={() => {
                                            history.push({
                                                pathname: "/home",
                                            });
                                        }}
                                        type="button"
                                        className="btnOkTest"
                                    >
                                        Back
                                    </button>
                                    <button
                                        type="submit"
                                        className="btnNextTest"
                                    >
                                        Submit
                                    </button>
                                </div>
                            </Col>
                        </Row>
                    </form>
                </div>
                <div>{resultData != null ? checkType(resultData) : ""}</div>
            </CardBody>
        </div>
    ) : (
        <Spinner spiner={true} />
    );
};

export default TestWithGPT;
